<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: button semantics are bound conditionally on the clickable prop, which Biome cannot resolve statically -->
<script setup lang="ts">
  import {
    chipClass,
    chipVariantClass,
    fixedWidthChipClass,
    squaredChipClass,
    boldChipClass,
  } from './Chip.css';
  import { computed } from 'vue';
  import {
    clickableClass,
    disabledClass,
    textEllipsisClass,
    textUppercaseClass,
  } from '@tundr/theme';
  import { ChipVariant } from './Chip.types.ts';

  export type DividerProps = {
    id?: string;
    testId?: string;
    title?: string;
    textEllipsis?: boolean;
    squared?: boolean;
    disableUppercase?: boolean;
    fixedWidth?: boolean;
    disabled?: boolean;
    clickable?: boolean;
    variant?: ChipVariant;
    disableBold?: boolean;
  };

  const emit = defineEmits<{
    click: [event?: Event];
  }>();

  const props = withDefaults(defineProps<DividerProps>(), {
    textEllipsis: true,
    disableUppercase: true,
    disableBold: false,
    fixedWidth: false,
    clickable: false,
  });

  const chipClasses = computed(() => [
    chipClass,
    chipVariantClass[props.variant || ChipVariant.LIGHT],
    {
      [textUppercaseClass]: !props.disableUppercase,
      [squaredChipClass]: props.squared,
      [clickableClass]: props.clickable,
      [fixedWidthChipClass]: props.fixedWidth,
      [boldChipClass]: !props.disableBold,
      [disabledClass]: props.disabled,
    },
  ]);

  const chipTextClasses = computed(() => [
    {
      [textEllipsisClass]: props.textEllipsis,
    },
  ]);

  const onKeyActivate = () => {
    if (!props.clickable || props.disabled) return;
    emit('click');
  };
</script>

<template>
  <div
    :title="title"
    :id="id || testId"
    :data-test-id="testId"
    :class="chipClasses"
    :role="clickable ? 'button' : undefined"
    :tabindex="clickable && !disabled ? 0 : undefined"
    @click="$emit('click')"
    @keydown.enter="onKeyActivate"
    @keydown.space.prevent="onKeyActivate"
  >
    <slot name="icon" />
    <span :class="chipTextClasses"><slot /></span>
    <slot name="iconRight" />
  </div>
</template>
